import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import SpecificationsTableContainer from '../../../modules/specifications/components/SpecificationsTableContainer';
import Button from '../../../components/buttons/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { hasPermission } from '../../../utils/HelperFunctions';

const Specifications = () => {
  const { t } = useTranslation();
  const { slug } = useParams()

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: `admin/specs-groups/${slug}`,
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.specifications'),
    withPagination: true,
    queryKey: 'specs',
    extraParams: {
      specs: 1
    },
    customSearchPlaceholder: `${t("search_by")} ${t("name")}`
  });


  const tableHeaders = [{ label: t('name_en') }, { label: t('name_ar') }, { label: t('type') },
  hasPermission(['specs.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ].filter(Boolean);;


  const navigate = useNavigate();

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="specifications-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">{searchEle}</div>
        <Button text={t('create_specification')} onClick={() => navigate(`/specification-groups/specifications/${slug}/create-specification`)} />
      </ListHeader>
      <SpecificationsTableContainer tableHeaders={tableHeaders} data={apiData?.specs} lessColumns noDataMessage={t('no_specifications_found')} />
      {paginationEle}
    </div>
  );
};

export default Specifications;
